import { Row, Tooltip, Column } from "@bridgesplit/ui";
import { Divider } from "@mui/material";
import { useVaultApyBreakdown } from "@bridgesplit/abf-react";

import { BaseApy } from "./BaseApy";
import { ExternalRewardsDisplay, RateDisplay, TooltipContent, useLendVaultAdditionalStats } from "./common";
import { RewardsDailyPoints } from "./daily-rewards";
import { RewardsExternalPointsRewards } from "./external-point-rewards/RewardsExternalPointsReward";
import { RewardsLendVaultApyProps } from "./types";

export function RewardsLendVaultApy(props: RewardsLendVaultApyProps) {
    const breakdown = useVaultApyBreakdown(props);

    return (
        <Tooltip noPadding title={<RewardsLendVaultTooltip {...props} />} reverseColors>
            <Row spacing={1} sx={{ flexDirection: props.reverse ? "row-reverse" : "row" }} alignItems="center">
                <ExternalRewardsDisplay
                    {...props}
                    externalRewardsVault={props.lendingVaultExpanded?.vaultRewardsSchedules}
                />
                <RateDisplay apy={breakdown?.totalApy} variant="body1" color="body" isFeatured={props.isFeatured} />
            </Row>
        </Tooltip>
    );
}

function RewardsLendVaultTooltip(props: RewardsLendVaultApyProps) {
    const combinedStats = useLendVaultAdditionalStats(props.lendingVaultExpanded);

    return (
        <TooltipContent px={0} py={1.5} spacing={1}>
            <Column px={1.5} spacing={0.5}>
                <BaseApy variant="body2" {...props} additionalStats={combinedStats} />
            </Column>
            <Divider />
            <RewardsDailyPoints {...props} />
            {props.externalPointRewards && (
                <>
                    <Divider />
                    <RewardsExternalPointsRewards {...props} />
                </>
            )}
        </TooltipContent>
    );
}
